import Grid2 from "@mui/material/Grid2";
import React from "react";
import { useFormContext } from "react-hook-form";
import FormTextField from "../../Common/FormTextField";
import { getFieldPath } from "../../Common/SchemaUtils";

const NameFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
}> = ({ extractionId, extractionPath }) => {
  const { control } = useFormContext();
  return (
    <Grid2
      container
      spacing={1}
      key={getFieldPath([extractionId, extractionPath])}
    >
      <Grid2 size={2}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.civility`}
          control={control}
          label="Civilité"
        />
      </Grid2>
      <Grid2 size={5}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.firstname`}
          control={control}
          label="Prénom"
        />
      </Grid2>
      <Grid2 size={5}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.lastname`}
          control={control}
          label="Nom de famille"
        />
      </Grid2>
    </Grid2>
  );
};

export default NameFormFields;
